import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import * as FileSystem from 'expo-file-system';

const ResourceButton = ({ codigo, nombre, ejes, tags, version }) => {

    console.log("----------------CREAR BUTTON-----------------")

    const navigation = useNavigation();

    let setresource = (object) => {
        console.log("Elegido curso");
        console.log(Platform.OS)

        var location = "../assets/json/misrecursos/" + codigo + ".json";
        
        navigation.navigate("Situación", { nombre, codigo, location, tags })
    }


    console.log(nombre);
    console.log(ejes);

    return (
        <View>
            <View style={styles.resursoview}>
              <Button
                 title= { nombre["esp"] } 
                 onPress= { setresource }
                 onClick= { setresource }
              />

            </View>
              <Text>{ejes}, {codigo} </Text>
           
        </View> 
    );
};

const styles = StyleSheet.create({
    resursoview: {
        padding: 6,   
        flexGrow: 1
      },
    buttonDownload: {
        maxWidth: 120,
        backgroundColor: 'red',
    }
});

export default ResourceButton